var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "crowdfund-token" }, [
    _c("div", { staticClass: "crowdfund-token-header" }, [
      _c("div", { staticClass: "crowdfund-token__icon-wrapper" }, [
        _vm.token.logoUrl
          ? _c("img", {
              staticClass: "crowdfund-token__icon",
              attrs: {
                src: _vm.token.logoUrl,
                alt: _vm.documentTypes.tokenIcon
              }
            })
          : _c("div", { staticClass: "crowdfund-token__icon" }, [
              _vm._v(_vm._s(_vm.token.name.substr(0, 1).toUpperCase()))
            ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "crowdfund-token__name-wrapper" }, [
        _c("h2", { staticClass: "crowdfund-token__name" }, [
          _vm._v(_vm._s(_vm.token.name))
        ]),
        _vm._v(" "),
        _c("h2", { staticClass: "crowdfund-token__code" }, [
          _vm._v("(" + _vm._s(_vm.token.code) + ")")
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "crowdfund-token-main" }, [
      _c(
        "div",
        { staticClass: "details-column md-layout-item" },
        [
          _c("detail-row", {
            attrs: {
              prop: _vm.i18n.lbl_token_max_issuance_amount(),
              value: _vm.i18n.c(_vm.token.max) + " " + _vm.token.code
            }
          }),
          _vm._v(" "),
          _c("detail-row", {
            attrs: {
              prop: _vm.i18n.lbl_token_initial_preissued_amount(),
              value: _vm.i18n.c(_vm.token.issued) + " " + _vm.token.code
            }
          }),
          _vm._v(" "),
          _c("detail-row", {
            attrs: {
              prop: _vm.i18n.lbl_avalilable_for_iss(),
              value: _vm.i18n.c(_vm.token.available) + " " + _vm.token.code
            }
          }),
          _vm._v(" "),
          _vm.token.termsUrl
            ? _c("detail-row", {
                attrs: {
                  prop: _vm.i18n.lbl_terms(),
                  value:
                    "<a href='" +
                    _vm.token.termsUrl +
                    "' target='_blank'>Open file</a>"
                }
              })
            : _c("detail-row", { attrs: { prop: _vm.i18n.lbl_terms() } }),
          _vm._v(" "),
          _c("detail-row", {
            attrs: {
              prop: _vm.i18n.sale_investor_income(),
              value:
                "" +
                (_vm.sale.investorIncome !== undefined
                  ? _vm.sale.investorIncome + "%"
                  : "—")
            }
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2649e3bd", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2649e3bd","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/app/sales/sale_details/tabs/Sales.TokenTab.vue
// module id = 8Wza
// module chunks = 1